import { createFeatureSelector, createSelector } from '@ngrx/store';

import { IReportState } from '@shared/types/report';

export const selectReportsFeature = createFeatureSelector<Readonly<IReportState>>('reports');

export const selectReportsAndSelectedReport = createSelector(selectReportsFeature, (state) => ({
    reports: state.reports,
    selectedReport: state.selectedReport,
}));

export const selectAllReports = createSelector(selectReportsFeature, (state) => ({ reports: state.reports }));

export const selectActiveReport = createSelector(selectReportsFeature, (state) => state.selectedReport);

export const selectActiveReportPermissions = createSelector(
    selectReportsFeature,
    (state) => state.selectedReport?.required_permissions,
);

export const selectActiveReportId = createSelector(selectReportsFeature, (state) => state.selectedReport?.id);

export const selectReportState = createSelector(selectReportsFeature, (state) => state);

export const selectReportUrl = createSelector(selectReportsFeature, (state) => state.reportUrl);

export const selectSubmittedTime = createSelector(selectReportsFeature, (state) => state.submittedTime);

export const selectEtlStatistic = createSelector(selectReportsFeature, (state) => state.etlStatistic);

export const selectReportFilters = createSelector(selectReportsFeature, (state) => state.reportFilters);

export const selectDashboardLastRunFilters = createSelector(
    selectReportsFeature,
    (state) => state.dashboardLastRunFilter,
);

export const selectReportsHistory = createSelector(selectReportsFeature, (state) => state.reportsHistory);

export const selectDashboardSettings = createSelector(selectReportsFeature, (state) => ({
    show_history_data: state.dashboard.show_history_data,
    execute_automatically: state.dashboard.execute_automatically,
}));

export const selectDashboardTitle = createSelector(selectReportsFeature, (state) => ({
    title: state.dashboard.title,
}));

export const selectDashboardOptions = createSelector(selectReportsFeature, (state) => ({
    stats: state.dashboard.stats,
    hasActiveLaborMatrix: state.dashboard.hasActiveLaborMatrix,
}));

export const selectReportIsUpdating = createSelector(selectReportsFeature, (state) => ({
    action: state.reportAction,
    report: state.selectedReport,
}));
